import { Application } from '@/models/applications/application';
import { Invitation } from '@/models/users/user-invitations/invitation';
import { appService, axiosService } from '.';

export default class UserInvitationsService {
    public async getDestinationApplications(): Promise<Application[]> {
        const response = await axiosService.instance.get('applications/organization/get-all-by-user-sign-in-enabled?userSignInEnabled=true');
        return response.data.map((app: any) => new Application(app));
    }

    public async newInvitation(invitation: Invitation): Promise<boolean> {
        const application = appService.getCurrentApplication();
        const returnUrlPart =
            application.id === invitation.destinationApplicationId
                ? invitation.associationId
                    ? '/dashboard?platformInvitationId={0}&associationId={2}&ui_locales='
                    : invitation.businessId
                    ? '/dashboard?platformInvitationId={0}&businessId={2}&ui_locales='
                    : '/dashboard?platformInvitationId={0}&ui_locales='
                : '?ui_locales=';

        invitation.originApplicationId = application.id;
        invitation.originApplicationName = `${application.clientName} (${application.clientUri})`;
        const appClientId = invitation.destinationApplicationClientId !== undefined ? invitation.destinationApplicationClientId : application.clientId;
        const appClientIdParam = appClientId ? `&appClientId=${appClientId}` : '';
        invitation.acceptanceUrlFormat = `${process.env.VUE_APP_IDENTITY_SERVER_URL}/Account/Register?invitationId={0}${appClientIdParam}&ui_locales={1}`;

        return (await axiosService.instance.post('users/organization/invitations/new', invitation)).data;
    }

    public async resendInvitation(id: number): Promise<boolean> {
        return (await axiosService.instance.post(`users/organization/invitations/resend/${id}`)).data;
    }
}

export const userInvitationsService = new UserInvitationsService();
